module.exports = "mutation deletePartner($id:String!){deletePartner(id:$id){success}}"